import type { OnDestroy, OnInit } from '@angular/core';
import { Component, inject, ViewChild, ViewContainerRef } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DropdownComponent } from '@core/user-interface-legacy';
import type { WysiwygLink } from '@core/wysiwyg-legacy';

import { SchedulerLinksDropdownToken } from './scheduler-links-dropdown';

@Component({
  selector: 'rt-scheduler-links-dropdown',
  templateUrl: './scheduler-links-dropdown.component.html',
  imports: [DropdownComponent],
})
export class SchedulerLinksDropdownComponent implements OnInit, OnDestroy {
  public select: (val: WysiwygLink) => void;
  public close: () => void;

  public schedulerLinkDropdownComponent = inject(SchedulerLinksDropdownToken);

  @ViewChild('componentOutlet', { read: ViewContainerRef, static: true })
  public componentOutlet: ViewContainerRef;
  private ngOnDestroy$ = new Subject<void>();

  public ngOnInit() {
    const componentRef = this.componentOutlet.createComponent(this.schedulerLinkDropdownComponent);
    componentRef.setInput('step', 'schedules');
    componentRef.setInput('hasBackAction', false);
    componentRef.setInput('isProsemirror', true);

    const { insertLink, closeDropdown } = componentRef.instance;

    outputToObservable(insertLink)
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(link => this.select(link));
    outputToObservable(closeDropdown)
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(() => this.close());
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
